// extracted by mini-css-extract-plugin
export default {"mask_bg":"Mask_mask_bg__Bp5LA","mask":"Mask_mask__PNigM"};